module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "simple-card",
    staticStyle: {
      "background-color": "#F8F8F8"
    }
  }, [_c('h3', {
    staticClass: "simple-card-title",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.leaderboard")))]), _vm._v(" "), (_vm.leaderboard.length > 0) ? _c('div', {
    attrs: {
      "id": "leaderboard"
    }
  }, [_c('div', {
    staticClass: "ribbon"
  }), _vm._v(" "), _c('table', _vm._l((_vm.leaderboard.slice(0, 6)), function(user, index) {
    return _c('tr', {
      key: user.username
    }, [(user.place) ? _c('td', {
      staticClass: "number"
    }, [_vm._v(_vm._s(user.place + 1))]) : (index == 0) ? _c('td', {
      staticClass: "number",
      staticStyle: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(index + 1))]) : _c('td', {
      staticClass: "number"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (user.place) ? _c('td', {
      staticClass: "name",
      staticStyle: {
        "font-weight": "bold",
        "color": "#00a65a"
      }
    }, [_vm._v(_vm._s(user.username))]) : (index == 0) ? _c('td', {
      staticClass: "name",
      staticStyle: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.username))]) : _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(user.username))]), _vm._v(" "), (user.place) ? _c('td', {
      staticClass: "points"
    }, [_vm._v(_vm._s(user.ratingGlicko))]) : (index == 0) ? _c('td', {
      staticClass: "points",
      staticStyle: {
        "color": "white"
      }
    }, [_vm._v("\n          " + _vm._s(user.ratingGlicko) + "\n          "), (index == 0) ? _c('img', {
      staticClass: "gold-medal",
      attrs: {
        "src": "https://github.com/malunaridev/Challenges-iCodeThis/blob/master/4-leaderboard/assets/gold-medal.png?raw=true",
        "alt": "gold medal"
      }
    }) : _vm._e()]) : _c('td', {
      staticClass: "points"
    }, [_vm._v("\n          " + _vm._s(user.ratingGlicko) + "\n          "), (index == 0) ? _c('img', {
      staticClass: "gold-medal",
      attrs: {
        "src": "https://github.com/malunaridev/Challenges-iCodeThis/blob/master/4-leaderboard/assets/gold-medal.png?raw=true",
        "alt": "gold medal"
      }
    }) : _vm._e()])])
  }), 0)]) : _c('div', [_c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.leaderboardEmpty')))])])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cf179192", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf179192"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rating/cards/Leaderboard.vue
// module id = 1474
// module chunks = 1